export default __webpack_public_path__ + "static/media/hero-portrait.65bb5963.svg";